<template>
  <div>
    <header class="modal-header py25 px65 h1 sans-serif weight-700 bg-cl-secondary">
      {{ $t('Reset password') }}
      <i
        slot="close"
        class="modal-close material-icons cl-bg-tertiary"
        @click="close"
      >
        close
      </i>
    </header>
    <div class="modal-content bg-cl-primary pt30 pb60 px65 cl-secondary">
      <template v-if="!passwordSent">
        <form @submit.prevent="sendEmail" novalidate>
          <div class="mb20">
            <p class="mb45">
              {{
                $t(
                  "Enter your email to receive instructions on how to reset your password."
                )
              }}
            </p>
            <base-input
              type="email"
              name="email"
              v-model="email"
              focus
              :placeholder="$t('E-mail address *')"
              :validations="[
                {
                  condition: !$v.email.required && $v.email.$error,
                  text: $t('Field is required.')
                },
                {
                  condition: !$v.email.email && $v.email.$error,
                  text: $t('Please provide valid e-mail address.')
                }
              ]"
            />
          </div>
          <button-full class="mb35" type="submit">
            {{ $t('Reset password') }}
          </button-full>
          <div class="center-xs">
            {{ $t('or') }}
            <a href="#" @click.prevent="switchElem">
              {{ $t('return to log in') }}
            </a>
          </div>
        </form>
      </template>
      <template v-if="passwordSent">
        <div class="modal-content pt30 pb60 px65 cl-secondary">
          <form @submit.prevent="confirmReset" novalidate>
            <p class="mt0 mb40">
              {{
                $t(
                  "We've sent a verification code to your email. Check your inbox and set new password"
                )
              }}
            </p>
            <base-input
              class="mb10"
              type="email"
              name="email"
              focus
              v-model="email"
              :placeholder="$t('E-mail address *')"
              :validations="[
                {
                  condition: !$v.email.required && $v.email.$error,
                  text: $t('Field is required.')
                },
                {
                  condition: !$v.email.email && $v.email.$error,
                  text: $t('Please provide valid e-mail address.')
                }
              ]"
            />
            <base-input
              class="mb10"
              type="password"
              name="verificationCode"
              v-model="verificationCode"
              :placeholder="$t('Verification code *')"
              :validations="[
                /*{
              condition: !$v.activation_code.required && $v.activation_code.$error,
              text: $t('Field is required.')
            }*/
              ]"
            />
            <base-input
              class="mb10"
              type="password"
              name="password"
              v-model="password"
              :placeholder="$t('Password *')"
              :validations="[
                /*{
              condition: !$v.password.required && $v.password.$error,
              text: $t('Field is required.')
            }*/
              ]"
            />
            <p class="mt0 mb40">
              {{
                $t(
                  "Password must contain at least 8 characters (at least 1 special character, 1 uppercase letter, 1 lowercase letter, 1 number)."
                )
              }}
            </p>
            <base-input
              class="mb10"
              type="password"
              name="new-password"
              v-model="rPassword"
              :placeholder="$t('Repeat password *')"
              :validations="[
                /*{
              condition: !$v.rPassword.required && $v.rPassword.$error,
              text: $t('Field is required.')
            },
            {
              condition: !$v.rPassword.sameAsPassword && $v.rPassword.$error,
              text: $t('Passwords must be identical.')
            }*/
              ]"
            />
            <div class="row">
              <div class="col-sm-6">
                <a href="#" class="btn btn--dark-blue btn--medium btn--block" @click.prevent="switchElem" data-testid="registerLink">
                  {{ $t("Cancel") }}
                </a>
              </div>
              <div class="col-sm-6">
                <button-full class="mb20 btn btn--orange btn--medium btn--block" type="submit" data-testid="loginSubmit">
                  {{ $t("Reset password") }}
                </button-full>
              </div>
            </div>
          </form>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import BaseInput from '../Form/BaseInput.vue'
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
import { Logger } from '@vue-storefront/core/lib/logger'
import i18n from '@vue-storefront/i18n'
export default {
  validations: {
    email: {
      required,
      email
    },
    verificationCode: {
      minLength: minLength(6),
      required
    },
    password: {
      minLength: minLength(8),
      required
    },
    rPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  methods: {
    close () {
      this.$bus.$emit('modal-hide', 'modal-signup')
    },
    sendEmail () {
      // todo: send email with reset password instructions
      if (this.$v.email.$invalid) {
        this.$v.$touch();
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: i18n.t('Please fix the validation errors'),
          action1: { label: i18n.t('OK') }
        });
        return;
      }
      this.$bus.$emit(
        'notification-progress-start',
        i18n.t('Resetting the password ... ')
      );
      this.$store
        .dispatch('user/resetPassword', { email: this.email })
        .then(response => {
          this.$bus.$emit('notification-progress-stop');
          if (response.code === 200) {
            this.passwordSent = true;
          } else {
            this.$store.dispatch('notification/spawnNotification', {
              type: 'error',
              message:
                i18n.t(response.result) ||
                i18n.t('Error while sending reset password e-mail'),
              action1: { label: i18n.t('OK'), action: 'close' }
            });
          }
        })
        .catch(err => {
          console.error(err);
          this.$bus.$emit('notification-progress-stop');
        });
    },
    confirmReset () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: i18n.t('Please fix the validation errors'),
          action1: { label: i18n.t('OK') }
        })
        return
      }
      this.$bus.$emit(
        'notification-progress-start',
        i18n.t('Resetting the password ... ')
      );
      this.$store
        .dispatch('user/confirmResetPassword', { email: this.email, verificationCode: this.verificationCode, newPassword: this.password })
        .then(response => {
          this.$bus.$emit('notification-progress-stop');
          if (response.code === 200) {
            this.passwordSent = true;
            this.$bus.$emit('modal-hide', 'modal-signup');
            this.$store.dispatch('notification/spawnNotification', {
              type: 'success',
              message: this.$t('New password has been set'),
              action1: { label: this.$t('OK') }
            });
          } else {
            this.$store.dispatch('notification/spawnNotification', {
              type: 'error',
              message:
                i18n.t(response.result) ||
                i18n.t('Error while resetting password'),
              action1: { label: i18n.t('OK'), action: 'close' }
            });
          }
        })
        .catch(err => {
          console.error(err);
          this.$bus.$emit('notification-progress-stop');
        });
    },
    switchElem () {
      this.$store.commit('ui/setAuthElem', 'login')
    }
  },
  name: 'ForgotPass',
  data () {
    return {
      email: '',
      verificationCode: '',
      password: '',
      rPassword: '',
      passwordSent: false
    };
  },
  components: {
    ButtonFull,
    BaseInput
  }
}
</script>

<style lang="scss" scoped>
  .modal-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .modal-close{
    cursor: pointer;
  }
  .modal-content {
    @media (max-width: 400px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
</style>